import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { type ClientDto, storeClient } from '../../generated/client';
import { queryKeys } from '../../query-keys';
import { useClient } from '../queries';

export const useStoreClient = (): UseMutationResult<ClientDto, AxiosError, string> => {
    const queryClient = useQueryClient();
    const { data: client } = useClient();

    return useMutation({
        mutationFn: (uuid: string) => storeClient({ body: { partnerUuid: uuid } }).then((result) => result.data!),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.sessions(client?.partnerUuid) });
        },
    });
};
